export default __webpack_public_path__ + "static/media/quick_link_3.108769b9.svg";